<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.client_feedback_logs.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" title="Go back" />
                                    <TableSettings
                                        :allFields="
                                            tables.client_feedback_logs.allFields
                                        "
                                        :activeFields.sync="
                                            tables.client_feedback_logs.fields
                                        "
                                    />
                                </div>
                                <!-- Button back -->
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("answers_description") }}
                                </h6>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.client_feedback_logs.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.client_feedback_logs
                                                .fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20, 50],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.client_feedback_logs
                                            .columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.client_feedback_logs.rows
                                    "
                                    v-bind="tables.client_feedback_logs"
                                >
                                    <template #message="{ item }">
                                        <td>
                                            <div class="pre">
                                                <div class="pre__container">
                                                    <div class="span__pre">
                                                        <code>
                                                            {{ item.message }}
                                                        </code>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>
                                    <template #request_report="{ item }">
                                        <td>
                                            <div class="request-report">
                                                {{ item.request_report }}
                                            </div>
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'/campaigns.api/'+uuid+'/feedback/logs'"
                                                :table="tables.client_feedback_logs"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="
                                    tables.client_feedback_logs.total_pages > 0
                                "
                            >
                                <!-- Pagination delivery campaigns -->
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.client_feedback_logs.page
                                        "
                                        :pages="
                                            tables.client_feedback_logs
                                                .total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="
                                            tables.client_feedback_logs.loading
                                        "
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";

export default {
    name: "IntegrationLogsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonBack,
        TableSettings,
        FilterFields,
        ButtonExport
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                client_feedback_logs: {
                    fields: [
                        {
                            key: "external_user",
                            label: "#",
                            sorter: false,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "type",
                            label: "type",
                            sorter: false,
                            filter: true,
                            _filter: false,
                            _style: "width:10%",
                        },
                        {
                            key: "message",
                            label: "message",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _style: "width:20%",
                        },
                        {
                            key: "header_code_server",
                            label: "response_code",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            _style: "width:25%",
                        },
                        {
                            key: "request_report",
                            label: "request_report",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _style: "width:35%",
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 5,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.query.client_id;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "client_feedback_logs",
                url: `/campaigns.api/${this.uuid}/feedback/logs`,
            });
            this.updatePageLoading(false);
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss">
/* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
.message__container {
    overflow: hidden;
}

.pre {
    & .pre__container {
        max-width: 30rem;
        overflow: auto;
        & .span__pre {
            display: block;
            unicode-bidi: embed;
            font-family: monospace;
            /* white-space: pre; */
            white-space: pre-wrap;
        }
    }
}
</style>